<div style="display: flex">
  <button [mdePopoverTriggerFor]="filterPopover"
    color="primary"
    mat-icon-button
    mdePopoverTriggerOn="hover">
    <mat-icon>search</mat-icon>
  </button>

  @if (selected) {
    <div class="filter-template">
      {{selected.name}}
      <button (click)="openFilterDialog()"
        color="primary"
        mat-icon-button>
        <mat-icon>edit</mat-icon>
      </button>
      <button (click)="resetSelected()"
        color="warn"
        mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>

<mde-popover
  #filterPopover="mdePopover"
  [mdePopoverCloseOnClick]="true"
  [mdePopoverOverlapTrigger]="false"
  mdePopoverPositionY="below">

  <mat-card appearance="outlined">
    <mat-card-title>
      <button (click)="openFilterDialog()" color="primary" mat-stroked-button>
        {{ 'ORDERS.FILTERS.editor' | translate }}
        <mat-icon>edit</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-content>
      <div style="display: grid; row-gap: 10px">
        @for (filter of templates$ | async; track filter) {
          <button (click)="applySelected(filter)" color="primary" mat-button>
            {{ filter.name }}
          </button>
        }
      </div>
    </mat-card-content>
  </mat-card>
</mde-popover>
